// src/config/roleConfig.js

// Commom
import Dashboard from "./Dashboard/Dashboard";
import Questionnaire from "./Questionnaire/Questionnaire";
import TicketStatus from "./TicketStatus/TicketStatus";

// ApproverPages
import ApproverApproved from "./ApproverPages/Approved/Approved";
import ApproverPending from "./ApproverPages/Pending/Pending";
import ApproverRejected from "./ApproverPages/Rejected/Rejected";
import CloseTicket from "./ApproverPages/Close/Close";

// PerformerPages
import PerformerApproved from "./PerformerPages/Approved/Approved";
import PerformerPending from "./PerformerPages/Pending/Pending";
import PerformerRejected from "./PerformerPages/Rejected/Rejected";
import Company from "./PerformerPages/Company/Company";
import Shareholder from "./PerformerPages/Shareholder/Shareholder";
import ELProcess from "./PerformerPages/ELProcess/ELProcess";
import EVerification from "./PerformerPages/EVerification/EVerification";
import SRN from "./PerformerPages/SRN/SRN";
import PendingSRN from "./PerformerPages/PendingSRN/PendingSRN";

import withAllowedRoles from "../hocs/withAllowedRoles/withAllowedRoles";
import { USER_TYPE } from "../constants";
import InApprovel from "./PerformerPages/InApprovel/InApprovel";
import RTARectify from "./RTAPages/RTARectify/RTARectify";

// Define component role mappings
const componentRoles = {
  Dashboard: [USER_TYPE.APPROVER, USER_TYPE.PERFORMER, USER_TYPE.RTA, USER_TYPE.ADMIN, USER_TYPE.AUDITOR],
  TicketStatus: [USER_TYPE.RTA, USER_TYPE.APPROVER, USER_TYPE.PERFORMER,USER_TYPE.AUDITOR],

  Questionnaire: [USER_TYPE.APPROVER, USER_TYPE.PERFORMER, USER_TYPE.RTA,USER_TYPE.AUDITOR],

  RTARectify: [USER_TYPE.RTA],

  ApproverApproved: [USER_TYPE.APPROVER],
  ApproverPending: [USER_TYPE.APPROVER],
  ApproverRejected: [USER_TYPE.APPROVER],
  CloseTicket: [USER_TYPE.APPROVER],

  PerformerApproved: [USER_TYPE.PERFORMER],
  PerformerInApproval: [USER_TYPE.PERFORMER],
  PerformerPending: [USER_TYPE.PERFORMER],
  PerformerRejected: [USER_TYPE.PERFORMER],
  Company: [USER_TYPE.PERFORMER],
  Shareholder: [USER_TYPE.PERFORMER],
  ELProcess: [USER_TYPE.PERFORMER],
  EVerification: [USER_TYPE.PERFORMER],
  SRN: [USER_TYPE.PERFORMER],
  PendingSRN: [USER_TYPE.PERFORMER],
};

export const ProtectedComponents = {
  // Dashboard
  Dashboard: withAllowedRoles(Dashboard, componentRoles.Dashboard),

  TicketStatus: withAllowedRoles(TicketStatus, componentRoles.TicketStatus),

  // RTA
  RTARectify: withAllowedRoles(RTARectify, componentRoles.RTARectify),

  // ApproverPages
  ApproverApproved: withAllowedRoles(
    ApproverApproved,
    componentRoles.ApproverApproved
  ),
  Pending: withAllowedRoles(ApproverPending, componentRoles.ApproverPending),
  Rejected: withAllowedRoles(ApproverRejected, componentRoles.ApproverRejected),
  CloseTicket: withAllowedRoles(CloseTicket, componentRoles.CloseTicket),

  // PerformerPages
  PerformerApproved: withAllowedRoles(
    PerformerApproved,
    componentRoles.PerformerApproved
  ),
  PerformerInApproval: withAllowedRoles(
    InApprovel,
    componentRoles.PerformerInApproval
  ),
  PerformerPending: withAllowedRoles(
    PerformerPending,
    componentRoles.PerformerPending
  ),
  PerformerRejected: withAllowedRoles(
    PerformerRejected,
    componentRoles.PerformerRejected
  ),
  Company: withAllowedRoles(Company, componentRoles.Company),
  Shareholder: withAllowedRoles(Shareholder, componentRoles.Shareholder),
  ELProcess: withAllowedRoles(ELProcess, componentRoles.ELProcess),
  EVerification: withAllowedRoles(EVerification, componentRoles.EVerification),
  SRN: withAllowedRoles(SRN, componentRoles.SRN),
  PendingSRN: withAllowedRoles(PendingSRN, componentRoles.PendingSRN),

  // Questionnaire
  Questionnaire: withAllowedRoles(Questionnaire, componentRoles.Questionnaire),
};

export const ProtectedDashboard = ProtectedComponents.Dashboard;
export const ProtectedApproverApproved = ProtectedComponents.ApproverApproved;
export const ProtectedApproverPending = ProtectedComponents.Pending;
export const ProtectedApproverRejected = ProtectedComponents.Rejected;
export const ProtectedCloseTicket = ProtectedComponents.CloseTicket;

export const ProtectedRTARectify = ProtectedComponents.RTARectify;

export const ProtectedPerformerApproved = ProtectedComponents.PerformerApproved;
export const ProtectedPerformerInApproval = ProtectedComponents.PerformerInApproval;
export const ProtectedPerformerPending = ProtectedComponents.PerformerPending;
export const ProtectedPerformerRejected = ProtectedComponents.PerformerRejected;
export const ProtectedCompany = ProtectedComponents.Company;
export const ProtectedShareholder = ProtectedComponents.Shareholder;
export const ProtectedELProcess = ProtectedComponents.ELProcess;
export const ProtectedEVerification = ProtectedComponents.EVerification;
export const ProtectedSRN = ProtectedComponents.SRN;
export const ProtectedPendingSRN = ProtectedComponents.PendingSRN;

export const ProtectedQuestionnaire = ProtectedComponents.Questionnaire;
export const ProtectedTicketStatus = ProtectedComponents.TicketStatus;
